import { createContext } from "react";

export interface KnowledgeTrainingContextValue {
  trainingStatus?: "in_process" | "completed";
  isTrainingStatusLoading: boolean;
  isTrainingStatusError: boolean;
  isTrainingStatusFetching: boolean;
  isTotalSizeExceeded: boolean;
  isTrainingLoading: boolean;
  trainingStatusRefetch: () => void;
  trainAgent: (untrainedKnowledge: string[]) => Promise<boolean>;
}

export const KnowledgeTrainingContext =
  createContext<KnowledgeTrainingContextValue | null>(null);
